import SimpleFormComponent from 'components/forms/simple';
import {Form, Formik} from 'formik';
import Header from 'modules/header/wholesaler/main';
import {Schema} from './utilities/validationSchema';
import usePostEditAd from '../../hooks/usePostEditAd';
import {formDataCreator} from '../../utilities/formDataCreatot';
import useSetAnswers from 'pages/farm/createAd/form/owner/simple/hooks/useSetAnswers';
import {useState} from 'react';
import {useParams} from 'react-router-dom';
import useGetPostDetail from 'pages/farm/productDetail/hooks/useGetPostDetail';
import {useFarm} from 'context/farmContext';

const SimpleForm = () => {
  const {farm} = useFarm();
  const {guid} = useParams();
  const {productDetail} = useGetPostDetail(guid || '');
  const {isLoading, mutate} = usePostEditAd();
  const {answers, handleAnswers} = useSetAnswers();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  return (
    <>
      <Header title="ثبت آگهی فروش محصول " />
      <Formik
        initialValues={{
          negotiated_price: productDetail?.negotiated_price || false,
          price: productDetail?.price?.toString() || '',
          grade: false,
        }}
        validationSchema={Schema}
        onSubmit={values => {
          const formData = new FormData();

          formDataCreator(formData, farm, guid);

          values?.negotiated_price &&
            formData.append('negotiated_price', `${values?.negotiated_price}`);
          !values?.negotiated_price && formData.append('price', values?.price);
          if (answers.length > 0 && isChecked) {
            const answersGuid: string[] = [];
            answers.map(item => answersGuid.push(item.guid));
            formData.append('answers', answersGuid?.toString());
          }
          !isLoading && mutate(formData);
        }}
      >
        {({values}) => (
          <Form className="mt-8 px-3">
            <SimpleFormComponent
              values={values}
              isLoading={isLoading}
              subProduct={farm?.subProduct}
              handleAnswers={handleAnswers}
              answers={answers}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default SimpleForm;
